'use client'

export function CollectionSkeleton({ count }: { count: number }) {
  return (
    <div className="relative z-10 mt-8 size-full">
      <div className="container mx-auto size-full overflow-hidden rounded-2xl bg-white shadow-lg">
        <div className="grid size-full grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 ">
          {Array.from({ length: count }).map((_, index) => (
            <div key={index} className="h-[488px] animate-pulse rounded border-b border-r border-grey-300 bg-gray-300" />
          ))}
        </div>
      </div>
    </div>
  )
}
